document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collection-media-slider").forEach(function (el) {
    $(el).slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      cssEase: "linear",
      fade: true,
      slidesToShow: 1,
      prevArrow: `<button type="button" class="slick-prev custom-arrow">
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M8.33325 15L13.3333 10L8.33325 5" stroke="#D32C00" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="round"></path>
                      </svg>
        </button>`,
      nextArrow: `<button type="button" class="slick-next custom-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M8.33325 15L13.3333 10L8.33325 5" stroke="#D32C00" stroke-width="2.5" stroke-linecap="square" stroke-linejoin="round"></path>
                      </svg>
        </button>`,
    });
    el.addEventListener("mouseenter", function () {
      $(el).slick("slickNext");
    });

    el.addEventListener("mouseleave", function () {
      $(el).slick("slickPrev");
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  $("#size-guides-button").on("click", function () {
    $(".size-guide-popup").show();
    $("body").addClass("open-popup");
  });

  $(".size-guide-close").on("click", function () {
    $(".size-guide-popup").hide();
    $("body").removeClass("open-popup");
  });
});


let secondClassTimeout;

window.addEventListener('scroll', () => {
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const targetElement = document.querySelector('.header-wrapper');

  const firstClass = 'scrolled-past-header-index';
  const secondClass = 'column-grid-remove';
  const thirdClass = 'page-load-logo';

  // Handle first and second class logic
  if (scrollTop >= 100) {
    targetElement.classList.add(firstClass);
    clearTimeout(secondClassTimeout);
    secondClassTimeout = setTimeout(() => {
      targetElement.classList.add(secondClass);
    }, 300);
  } else {
    targetElement.classList.remove(firstClass, secondClass);
    clearTimeout(secondClassTimeout);
  }

  // Handle third class logic
  if (scrollTop < 110) {
    targetElement.classList.remove(thirdClass);
  }
});

if (screen.width > 749) {
window.addEventListener('scroll', () => {
  const header = document.querySelector('.section-header');
  const footer = document.querySelector('.footer__content-top');
  const footerTop = footer.getBoundingClientRect().top;
  const windowHeight = window.innerHeight;

  if (footerTop <= windowHeight) {
    header.classList.add('header-exit');
  } else {
    header.classList.remove('header-exit');
  }
});
}
